import FigmaLogo from '../assets/icons/figma.svg'
import ReactLogo from '../assets/icons/react.svg'
import GitLogo from '../assets/icons/git.svg'
import PostgreSqlLogo from '../assets/icons/postgresql.svg'
import NotionLogo from '../assets/icons/notion.svg'
import TailwindLogo from '../assets/icons/tailwind.svg'
import FlutterLogo from '../assets/icons/flutter.svg'
import JavascriptLogo from '../assets/icons/javascript.svg'
import AstroLogo from '../assets/icons/astro.svg'
import CSSLogo from '../assets/icons/css.svg'
import WordPressLogo from '../assets/icons/wordpress.svg'
import TypescriptLogo from '../assets/icons/typescript.svg'
import AngularLogo from '../assets/icons/angular.svg'
import NodejsLogo from '../assets/icons/nodedotjs.svg'
import SQLiteLogo from '../assets/icons/sqlite.svg'

export const TECH_LOGOS = [
	{
		src: FigmaLogo,
		alt: 'Figma',
		title: 'Figma',
		href: 'https://www.figma.com/',
		circleColor: 'rgba(162, 89, 255, 0.5)'
	},
	{
		src: ReactLogo,
		alt: 'React',
		title: 'React',
		href: 'https://react.dev/',
		circleColor: 'rgba(97, 218, 251, 0.5)'
	},
	{
		src: AngularLogo,
		alt: 'Angular',
		title: 'Angular',
		href: 'https://angular.io/',
		circleColor: 'rgba(220, 37, 184, 0.5)',
		imgStyle: { width: '50px' }
	},
	{
		src: GitLogo,
		alt: 'Git',
		title: 'Git',
		href: 'https://git-scm.com/',
		circleColor: 'rgba(222, 75, 54, 0.5)'
	},
	{
		src: NodejsLogo,
		alt: 'Node.js',
		title: 'Node.js',
		href: 'https://nodejs.org/',
		circleColor: 'rgba(74, 146, 65, 0.5)',
		imgStyle: { width: '50px' }
	},
	{
		src: PostgreSqlLogo,
		alt: 'PostgreSQL',
		title: 'PostgreSql',
		href: 'https://www.postgresql.org/',
		circleColor: 'rgba(33, 117, 155, 0.5)'
	},
	{
		src: SQLiteLogo,
		alt: 'SQLite',
		title: 'SQLite',
		href: 'https://www.sqlite.org/',
		circleColor: 'rgba(31, 138, 209, 0.5)',
		imgStyle: { width: '50px' }
	},
	{
		src: NotionLogo,
		alt: 'Notion',
		title: 'Notion',
		href: 'https://www.notion.so/',
		circleColor: 'rgba(0, 0, 0, 0.5)'
	},
	{
		src: TailwindLogo,
		alt: 'Tailwind CSS',
		title: 'Tailwind CSS',
		href: 'https://tailwindcss.com/',
		circleColor: 'rgba(6, 182, 212, 0.5)'
	},
	{
		src: FlutterLogo,
		alt: 'Flutter',
		title: 'Flutter',
		href: 'https://flutter.dev/',
		circleColor: 'rgba(61, 140, 209, 0.5)'
	},
	{
		src: JavascriptLogo,
		alt: 'JavaScript',
		title: 'JavaScript',
		href: 'https://www.javascript.com/',
		circleColor: 'rgba(233, 202, 51, 0.5)',
		imgStyle: { width: '50px' }
	},
	{
		src: TypescriptLogo,
		alt: 'TypeScript',
		title: 'TypeScript',
		href: 'https://www.typescriptlang.org/',
		circleColor: 'rgba(49, 120, 198, 0.5)',
		imgStyle: { width: '50px' }
	},
	{
		src: AstroLogo,
		alt: 'Astro',
		title: 'Astro',
		href: 'https://astro.build/',
		circleColor: 'rgba(0, 0, 0, 0.5)'
	},
	{
		src: CSSLogo,
		alt: 'CSS',
		title: 'CSS',
		href: '#',
		circleColor: 'rgba(6, 182, 212, 0.5)'
	},
	{
		src: WordPressLogo,
		alt: 'WordPress',
		title: 'WordPress',
		href: 'https://wordpress.org/',
		circleColor: 'rgba(33, 117, 155, 0.5)'
	}
]
